import XolabotXWM from './XolabotXWM';

export default XolabotXWM;
